"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var ObjectId = require('bson').ObjectID;
var clone = require('clone');
var tv4 = require('tv4');
var FamilyBand = /*#__PURE__*/function () {
  function FamilyBand(opt) {
    _classCallCheck(this, FamilyBand);
    this._id = null;
    this.name = null;
    this["class"] = null;
    this.key = null;
    this.campus = 'GLOBAL';
    this.tenant = 'GLOBAL';
    this.hideFromUser = false;
    this.requireSop = [];
    this.category = '';
    if (opt) {
      this.fillObject(clone(opt));
    }
  }
  _createClass(FamilyBand, [{
    key: "fillObject",
    value: function fillObject(opt) {
      this._id = new ObjectId(opt._id);
      this.name = opt.name || '';
      this["class"] = opt["class"] || null;
      this.key = opt.key || null;
      this.campus = opt.campus || 'GLOBAL';
      this.tenant = opt.tenant || 'GLOBAL';
      this.hideFromUser = !!opt.hideFromUser;
      this.requireSop = opt.requireSop || [];
      this.category = opt.category || '';
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, FamilyBand.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'family-band.schema.json',
        type: 'object',
        properties: {
          _id: {
            type: 'object'
          },
          name: {
            type: 'string'
          },
          "class": {
            type: ['string', 'null']
          },
          key: {
            type: ['string', 'null']
          },
          campus: {
            type: 'string'
          },
          tenant: {
            type: 'string'
          },
          hideFromUser: {
            type: 'boolean'
          },
          requireSop: {
            type: 'array',
            item: {
              type: 'string'
            }
          },
          category: {
            type: 'string'
          }
        },
        required: Object.keys(this)
      };
    }
  }]);
  return FamilyBand;
}();
module.exports = FamilyBand;